<template>
  <div>
    <v-card outlined>
      <v-card-title
          class="white--text text-uppercase pa-2 font-weight-bold d-flex justify-center text-subtitle-1"
          :class="{'red': product.rannge.slug === 'red-range',
                         'blue': product.rannge.slug === 'blue-range',
                         'grey': product.rannge.slug === 'diamant-range',
                         'purple': product.rannge.slug === 'rando-range',
                         'yellow darken-1': product.rannge.slug === 'infinity-range',
                         'black': product.rannge.slug === 'black-range'}">
        {{ product|appTranslate('name') }}
      </v-card-title>
      <v-card-text class="my-5">
        <div class="text-center mb-4">
          {{ product.level|appTranslate('name') }}
        </div>
        <div class="text--primary">
          {{ product|appTranslate('description') }}
        </div>
        <div class="d-flex align-baseline justify-space-around mt-4">
          <div class="d-flex flex-column">
            <span class="font-weight-bold">Tarif web</span>
            <strong class="text-h6 font-weight-bold red--text">{{ discountedPrice }} €</strong>
          </div>
          <div v-if="discountedPrice != regularPrice" class="d-flex flex-column">
            <span class="font-weight-bold">Tarif magasin</span>
            <span class="ml-auto">{{ regularPrice }} €</span>
            <span class="ml-auto red--text font-weight-bold" style="display: none;">
              {{ globalDiscount(regularPrice, discountedPrice) }} &percnt;
            </span>
          </div>
        </div>
        <div class="my-3 d-flex align-center justify-space-around">
          <div>
            <v-img height="400px" :src="`${apiUrl}/uploads/products-images/${product.image.filename}`" contain></v-img>
          </div>
          <div>
            <div v-for="(equipment, k) of product.productEquipments" :key="k" :class="{'mt-4':k > 0}">
              <v-img class="mb-2"
                     :src="`${apiUrl}/uploads/equipments-images/${equipment.image.filename}`"
                     max-width="80px"/>
              <v-checkbox
                  v-model="cartProduct.equipments[`${k}`]"
                  :input-value="equipment"
                  :label="equipment|appTranslate('name')"
                  dense
                  class="my-0 py-0 product-equipment"
              ></v-checkbox>
            </div>
          </div>
        </div>
        <div class="text-center">
          <v-btn class="d-inline-block py-2 px-3"
                 color="primary"
                 id="addToCart"
                 dark
                 depressed
                 large
                 outlined
                 @click.stop="addProductToCart()"
                 style="white-space:normal; height: auto">
            {{ 'add_pack'|globalTranslate }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar" timeout="2000" :top="true" :right="true" :color="snackbarColor">{{ snackbarMsg }}
    </v-snackbar>
  </div>
</template>

<script>
import snackbarMixin from "@/mixins/snackbarMixin";
import {getCartProductPrice, getCartProductPriceWithDiscount} from "@/utils"
import cartProductModel from "@/models/cartProduct";

export default {
  name: "ProductCard",
  computed: {
    // Price with discount if at least one
    discountedPrice() {
      const price = getCartProductPriceWithDiscount(this.$props.numberOfDays, this.cartProduct);
      return Number(price.toFixed(1));
    },
    // Price without discount
    regularPrice() {
      const price = getCartProductPrice(this.$props.numberOfDays, this.cartProduct);
      return Number(price.toFixed(1));
    }
  },
  data() {
    return {
      cartProduct: new cartProductModel(),
      checkedBoxes: []
    };
  },
  methods: {
    addProductToCart() {
      this.$emit("add-product-in-cart", {
        product: this.product,
        equipments: [...this.cartProduct.equipments]
      });
    },
    globalDiscount() {
      const regularPrice = getCartProductPrice(this.$props.numberOfDays, this.cartProduct);
      const discountedPrice = getCartProductPriceWithDiscount(this.$props.numberOfDays, this.cartProduct);
      const price = (discountedPrice - regularPrice) / regularPrice * 100;
      return Number(price.toFixed(0));
    },
  },
  mixins: [snackbarMixin],
  created() {
    this.cartProduct.hydrate({
      owner: '',
      product: this.$props.product,
      qty: this.$props.numberOfDays,
      equipments: [...this.$props.product.productEquipments].map((value, index) => {
        // Pre-check first equipement. Should be shoes.
        return 0 === index;
      })
    });
  },
  props: {
    apiUrl: {
      type: String,
      required: true
    },
    numberOfDays: {
      type: Number,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
